// @ts-nocheck
import axios from 'config/api';
import globalHeaders from 'utils/globalHeaders';
import { authenticated, api } from './index';

export const createTemplate = (payload) =>
  authenticated(api).post('/resource_code_list/', payload);

export const getTemplates = (params) =>
  authenticated(api).get('/resource_code_list/', { params });

export const getTemplate = (params) =>
  authenticated(api).get(`/resource_code_list/${params.templateId}/`);

export const updateTemplate = (params, payload) =>
  authenticated(api).put(`/resource_code_list/${params.templateId}/`, payload);

export const deleteTemplate = (params) =>
  authenticated(api).delete(`/resource_code_list/${params.templateId}/`);

export const cloneTemplate = (params) =>
  authenticated(api).post(
    `/resource_code_list/${params.templateId}/clone_this_list/`,
  );

export const exportResourceCodes = (params) =>
  authenticated(api).post(
    `/resource_code_list/${params.templateId}/export_resource_codes/`,
  );

export const createResourceCode = (payload) =>
  authenticated(api).post('/resource_codes/', payload);

export const getResourceCodes = (params) =>
  authenticated(api).get('/resource_codes/', { params });

export const updateResourceCode = async (params, payload) => {
  // const a =
  const response = await axios({
    method: 'PUT',
    url: `/resource_codes/${params.resourceCodeId}/`,
    data: payload,
    headers: { ...globalHeaders() },
    validateStatus: () => true,
  });
  return response;
};

export const forceUpdateResourceCode = (params, payload) =>
  authenticated(api).put(
    `/resource_codes/${params.resourceCodeId}/?force=${params?.force}`,
    payload,
  );

export const deleteResourceCode = (params) =>
  authenticated(api).delete(`/resource_codes/${params.resourceCodeId}/`);

export const createNote = (payload) =>
  authenticated(api).post('/resource_code_notes/', payload);

export const updateNote = (params, payload) =>
  authenticated(api).put(`/resource_code_notes/${params.noteId}/`, payload);

export const deleteNote = (params) =>
  authenticated(api).delete(`/resource_code_notes/${params.noteId}/`);

export const getSystemFields = (params) =>
  authenticated(api).get(
    `/resource_code_list/${params.templateId}/column_headers/`,
  );

export const checkUnidentifiedCostCodes = (payload) =>
  authenticated(api).post(
    '/resource_codes/check_unidentified_cost_codes/',
    payload,
  );

export const saveBulkResourceCodes = (params, payload) =>
  authenticated(api).post(
    `/resource_code_list/${params.templateId}/save_resource_codes/`,
    payload,
  );

export const checkDefaultCostCode = () =>
  authenticated(api).get('resource_code_list/has_default_cost_code/');

export const addDyanmicField = (params, payload) =>
  authenticated(api).patch(
    `/resource_code_list/${params.templateId}/`,
    payload,
  );

export const getSampleResourceCode = (params) =>
  authenticated(api).get(
    `/resource_code_list/${params.templateId}/sample_template_url/`,
  );

export const getResourceType = (params) =>
  authenticated(api).get(`/v1.1/resource-type/`);
